import { useCallback, useMemo } from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogPaper: {
      backgroundColor: "#eee",
      borderRadius: "15px",
      padding: "1em",
    },
  }),
);

const useEventEditDialog = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      dialogPaper: {
        paper: styles.dialogPaper,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const dispatch = useDispatch();

  const { isOpen, editMode, selectedEvent } = useSelector(
    selectors.EditEventDialogState,
  );

  const handleDialogClose = useCallback(() => {
    dispatch(
      actions.setEditEventDialogState({
        isOpen: false,
        editMode: false,
        selectedEvent: null,
      }),
    );
  }, [dispatch]);

  return {
    styles,
    classes,
    atomicStyles,
    isMobile,
    isOpen,
    editMode,
    handleDialogClose,
    selectedEvent,
  };
};

export { useEventEditDialog as default };
